import {Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ServiceProviderService} from '../../../../core/services/service-provider.service';
import {ServiceProviderInterface} from '../../../../core/interfaces/service-provider.interface';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import {Element} from '@angular/compiler/src/ml_parser/ast';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-autocomplete-service-provider',
  templateUrl: './autocomplete-service-provider.component.html',
  styleUrls: ['./autocomplete-service-provider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteServiceProviderComponent),
      multi: true
    }
  ]
})
export class AutocompleteServiceProviderComponent implements OnInit, ControlValueAccessor, OnDestroy {
  private observables: Subscription[] = [];
  public isFocus = false;
  protected dataSource: ServiceProviderInterface[] = [];
  public serviceproviderSelected: any;
  public showLoading: boolean;
  minCharacters = 200;
  @Input() isDisable = false;
  @Output() rowSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  public propagateChange: any  = () => {};
  constructor(protected service: ServiceProviderService, protected _sweetAlertHelper: SweetAlertHelper) {
    // this.getServiceProviders();
    this.showLoading = false;
  }
  getServiceProviders(search: String) {
    if (search && search.length > this.minCharacters) {
      this._sweetAlertHelper.captureException(
        'The search exceeds the maximum number of characters, please try again.'
      );
      return;
    }
    if (!search) {
      this.serviceproviderSelected = null;
    }
    this.showLoading = true;
    this.dataSource = [];
    this.observables.push(
      this.service.getByPtr(search).subscribe((data) => {
          this.dataSource = data;
          this.showLoading = false;
          this.focus();
        }
      ));
  }
  getServiceProvidersById(search: number) {
    this.dataSource = [];
    this.observables.push(
      this.service.getById(search).subscribe((data) => {
        this.serviceproviderSelected = data.description;
        this.dataSource.push(data);
        // this.clickrow(data);
      } ));
  }
  ngOnInit() {
  }

  /**
   * @name focusOut
   * @description Al salir del focus del input
   */
  focusOut () {
    setTimeout(() => {
      this.isFocus = false;
    }, 300);
  }
  /**
   * @name
   * @description AL hacer focus la input
   */
  focus () {
    this.isFocus = true;
  }
  clickrow(data) {
    this.focusOut();
    this.serviceproviderSelected = data.description;
    this.propagateChange(data.description);
    return this.rowSelected.emit(data);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.serviceproviderSelected = obj || '';
  }
  setDisabledState(isDisabled: boolean): void {
  }
  closeBtn() {
    return this.close.emit(true);
  }
  /**
   * @description foco de div del select
   */
  onBlur(event: boolean): void {
    if (event && this.dataSource.length) {
      this.isFocus = true;
    } else {
      this.isFocus = false;
    }
  }
  /**
   * @description para el borrado de Service Provider
   */
  onChangeSearch(event): void {
    if (!event) {
      this.dataSource = [];
      this.isFocus = false;
      this.propagateChange('');
      this.rowSelected.emit({ serviceproviderid: null, description: '' });
    }
  }
  onEnterService(key: number): void {
    if (key === 13) {
      this.getServiceProviders(this.serviceproviderSelected);
    }
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/autocomplete-service-provider/autocomplete-service-provider.component.ts